import { useState, useEffect } from 'react'
import Head from 'next/head'
// import Script from 'next/script'
// import dynamic from 'next/dynamic'
import { SearchOutlined } from '@ant-design/icons'
import Link from 'next/link'
import styles from './guide.module.scss'
// import Image from 'next/image'
import Router from 'next/router'
import { Input, Divider, Button, notification } from 'antd'
import { useSelector } from 'react-redux'
// import { Loader } from '@googlemaps/js-api-loader'
import { isOnlineDev } from '@utils'
import useLocation from '@/utils/hooks/useLocation'
// import useMobileDetect from '@/utils/isMobile'

const useMobileDetect = () => {
  if (typeof window === 'undefined') return false
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  function mq(query) {
    return typeof window !== 'undefined' && window.matchMedia(query).matches
  }
  // @ts-ignore
  if (
    'ontouchstart' in window ||
    (window?.DocumentTouch && document instanceof DocumentTouch)
  )
    return true
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('') // include the 'heartz' - https://git.io/vznFH
  return mq(query)
}

// const CodeSampleModal = dynamic(() => import('../components/CodeSampleModal'), {
//   ssr: false
// })
const isDev = process.env.NODE_ENV === 'development'

export default function Start(props) {
  const [form, setForm] = useState({
    location: props.location,
    'age-range': null,
    zone: null
  })
  const [latitude, setLatitude] = useState(null)
  const [longitude, setLongitude] = useState(null)
  const [locationSlide, setLocationSlide] = useState(false)
  const [history, setHistory] = useState([])
  const [token, setToken] = useState(null)
  const [isMobile, setIsMobile] = useState(false)
  const userInfo = useSelector((state) => state.auth.userInfo)
  const [precisionLat, setPrecisionLat] = useState(null)
  const [precisionLng, setPrecisionLng] = useState(null)
  const [googleService, setGoogleService] = useState(null)
  const [timer, setTimer] = useState(null)
  const [searchList, setSearchList] = useState([])
  const [maxHeight, setMaxHeight] = useState(150)

  const loc = useLocation(true)

  useEffect(() => {
    setToken(localStorage.getItem('TOKEN'))
    setIsMobile(useMobileDetect())
    setMaxHeight(
      document.documentElement.clientHeight - 620 > 150
        ? 150
        : document.documentElement.clientHeight - 620 < 60 &&
          document.documentElement.clientHeight - 620 > 0
        ? 60
        : document.documentElement.clientHeight - 620 < 0
        ? 0
        : document.documentElement.clientHeight - 620
    )
  }, [userInfo])

  useEffect(() => {
    let time = 0
    let timer = setInterval(() => {
      if (
        window &&
        window.google &&
        window.google.maps &&
        window.google.maps.places &&
        window.google.maps.places.AutocompleteService
      ) {
        time = 0
        clearInterval(timer)
        const service = new google.maps.places.AutocompleteService()
        setGoogleService(service)
      } else if (time === 10) {
        clearInterval(timer)
      } else {
        time += 1
      }
    }, 2000)
  }, [])

  useEffect(() => {
    const his = localStorage.getItem('location-history')
    try {
      const arr = JSON.parse(his)
      if (Array.isArray(arr)) {
        setHistory(arr)
      }
    } catch (error) {}
  }, [])

  const onSearch = () => {
    const query = {}
    for (const key in form) {
      if (Object.hasOwnProperty.call(form, key)) {
        if (form[key]) {
          query[key] = form[key]
          if (key === 'zone') {
            query.ll = `${longitude},${latitude}`
          }
          if (key === 'location' && form.location !== 'Current Location') {
            const his = history.filter((_) => _ !== form[key])
            his.unshift(form[key])
            localStorage.setItem('location-history', JSON.stringify(his))
            setTimeout(() => {
              setHistory(his)
            }, 200)
          } else if (
            key === 'location' &&
            form.location === 'Current Location' &&
            precisionLat &&
            precisionLng
          ) {
            query.ll = `${precisionLng},${precisionLat}`
          }
        }
      }
    }
    Router.push({ pathname: '/schools', query })
  }

  const getCurrentLocation = () => {
    return new Promise((res, rej) => {
      if (!precisionLat || !precisionLng) {
        if (navigator.geolocation) {
          // 支持geolocation
          navigator.geolocation.getCurrentPosition(function (position) {
            console.log(position)
            // Get the coordinates of the current position.
            var lat = position.coords.latitude
            var lng = position.coords.longitude
            setPrecisionLat(lat)
            setPrecisionLng(lng)
            res({ lat, lng })
          })
        } else {
          rej(false)
        }
      } else {
        res({ lat: precisionLat, lng: precisionLng })
      }
    })
  }

  const selectCurrentLocation = async (e) => {
    // await getCurrentLocation()
    console.log(loc)
    if (loc && loc[0] && loc[0].lat) {
      setPrecisionLat(loc[0].lat)
      setPrecisionLng(loc[0].lng)
      setForm({ ...form, location: 'Current Location' })
    } else {
      notification.error({ message: 'Unable to get your exact location' })
    }
  }

  const selectCurrentHistory = (text) => {
    setForm({ ...form, location: text })
  }

  const onBlurLocation = () => {
    setTimeout(() => {
      setLocationSlide(false)
    }, 200)
  }

  const onInputAddress = async (e) => {
    const address = e.target.value
    setForm({ ...form, location: address })
    const { lat, lng } = await getCurrentLocation()
    if (googleService) {
      clearTimeout(timer)
      let t = setTimeout(() => {
        if (address) {
          googleService.getQueryPredictions(
            {
              input: address,
              radius: 100,
              location: new google.maps.LatLng(lat, lng)
            },
            function (results) {
              setSearchList(results.map((_) => _.description))
            }
          )
        }
      }, 1000)
      setTimer(t)
    }
  }

  return (
    <div>
      <Head>
        <title>
          Y Montessori - Where Montessori Schools, Parents, and Data Meet.
        </title>
       <meta
         name='title'
         content='Find Montessori schools, foster seamless parent-educator connections, and access data-driven insights—all with Y Montessori.'
       />
        <link rel='icon' href='/favicon.ico' />
        <link
          href='https://fonts.googleapis.com/css2?family=Inter'
          rel='stylesheet'
        />
      </Head>

      <main className={styles.container}>
        <div className={styles.main}>
          <div className={styles.slides}>
            {isMobile ? (
              <img
                style={{ height: 'calc(100vh - 60px)' }}
                src='https://ymontessori.s3.us-west-1.amazonaws.com/uploads/230625/651c6a47a01dcac050efb0a93b7ff5f5.jpg'
                alt='welcome'
              ></img>
            ) : (
              <video width='100%' height='auto' autoPlay muted loop>
                <source
                  src='https://res.cloudinary.com/dbsiylseo/video/upload/v1673422993/video_efuu2v.mp4'
                  type='video/mp4'
                ></source>
              </video>
            )}
          </div>
          <div className={styles.filter}>
            <div className={styles.slidesInfo}>
              <h1>Y Montessori</h1>
              <p>Find Your Perfect Montessori School</p>
            </div>
            <div className={styles.filterItem}>
              {/* <div className={styles.filterItemTop}>Location</div> */}
              <div className={styles.filterItemBottom}>
                <div className={styles.filterItemBottomInput}>
                  <Input
                    placeholder='School name'
                    className={styles.input}
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    onPressEnter={(e) => {
                      setForm({ ...form, name: e.target.value })
                      onSearch()
                    }}
                    autoFocus={true}
                  />
                </div>
              </div>
            </div>
            <div className={styles.filterItem}>
              <div className={styles.filterItemBottom}>
                <div className={styles.filterItemBottomInput}>
                  <Input
                    placeholder='City, Zip Code, Address'
                    className={styles.input}
                    value={form.location}
                    onBlur={onBlurLocation}
                    onFocus={() => setLocationSlide(true)}
                    onChange={onInputAddress}
                    onPressEnter={(e) => {
                      setForm({ ...form, location: e.target.value })
                      onSearch()
                    }}
                  />
                  <div
                    className={styles.filterItemBottomInputSlide}
                    style={{ height: locationSlide ? 'auto' : 0 }}
                  >
                    <div
                      className={styles.filterItemBottomInputSlideCurrent}
                      onClick={selectCurrentLocation}
                    >
                      <img src='/position-current.png' alt='Current Location' />{' '}
                      Current Location
                    </div>
                    <div className={styles.filterItemBottomInputSlideHistory}>
                      {searchList.map((_) => (
                        <div
                          className={
                            styles.filterItemBottomInputSlideHistoryItem
                          }
                          key={_}
                          onClick={selectCurrentHistory.bind(null, _)}
                        >
                          <img src='/position2.png' alt='position' /> {_}
                        </div>
                      ))}
                      {history.map((_) => (
                        <div
                          className={
                            styles.filterItemBottomInputSlideHistoryItem
                          }
                          key={_}
                          onClick={selectCurrentHistory.bind(null, _)}
                        >
                          <img src='/history.png' alt='history' /> {_}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* <div
                    className={styles.filterItemBottomIcon}
                    onClick={() => setSelect2open(!select2open)}
                  >
                    <DownCircleOutlined
                      className={styles.filterItemBottomIconDetail}
                    />
                  </div> */}
              </div>
            </div>
            <div className={styles.filterItem}>
              <div className={styles.filterItemBtn} onClick={onSearch}>
                Search
              </div>
              <div className={styles.filterItemBtn2} onClick={onSearch}>
                {isMobile ? 'Search' : <SearchOutlined />}
              </div>
            </div>
            {userInfo &&
            userInfo.schools &&
            userInfo.schools.length &&
            maxHeight > 0 ? (
              <div
                style={{ width: '100%', display: 'flex', alignItems: 'center' }}
              >
                <div
                  className={styles.schoolExpressPortal}
                  style={{ minWidth: isMobile ? 'auto' : 600 }}
                >
                  <div className={styles.schoolExpressPortalTitle}>
                    You are the administrator of the following school, you can
                    quickly access it through the button below:
                  </div>
                  <div
                    className={styles.schoolExpressPortalContent}
                    style={{ maxHeight }}
                  >
                    {userInfo.schools.map((_, i) => (
                      <div
                        className={styles.schoolExpressPortalContentItem}
                        key={_.id}
                      >
                        <div
                          className={styles.schoolExpressPortalContentItemLeft}
                        >
                          <div
                            className={
                              styles.schoolExpressPortalContentItemLeftName
                            }
                          >
                            {_.name}
                          </div>
                          <div
                            className={
                              styles.schoolExpressPortalContentItemLeftAddress
                            }
                          >
                            {_.street_address && (
                              <span>{_.street_address}, </span>
                            )}
                            {_.locality && <span>{_.locality}, </span>}
                            {_.state && <span>{_.state}, </span>}
                            {_.zip_code}
                          </div>
                        </div>
                        <div
                          className={styles.schoolExpressPortalContentItemRight}
                        >
                          <Link href={`/school/${_.url}`}>
                            <Button type='primary'>Go to</Button>
                          </Link>
                          <Divider type='vertical' />
                          <a
                            href={`https://school.${
                              isDev || isOnlineDev ? 'dev.' : ''
                            }ymontessori.com/editschool?id=${
                              _.id
                            }&token=${token}&school_index=${i}`}
                            target='__blank'
                          >
                            Manage
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className={styles.intro}>
          <h2 className={styles.introTitle}>About Montessori Education</h2>
          <div className={styles.introDes}></div>
          <div className={styles.introList}>
            <div className={styles.introListItem}>
              <iframe
                width='400'
                height='285'
                src='https://www.youtube.com/embed/UzmvtVAuuyI'
                title='YouTube video player'
                frameBorder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              ></iframe>
            </div>
            <div className={styles.introListItem}>
              <iframe
                width='400'
                height='285'
                src='https://www.youtube.com/embed/UHsysBrO3wU'
                title='YouTube video player'
                frameBorder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              ></iframe>
            </div>
            <div className={styles.introListItem}>
              <iframe
                width='400'
                height='285'
                src='https://www.youtube.com/embed/Pb8kUvKcVTw?controls=0'
                title='YouTube video player'
                frameBorder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export async function getServerSideProps(context) {
  const ip = context.req.headers['x-real-ip'] || '104.177.116.181'
  let location = null
  try {
    const latlng1 = await fetch(
      `${process.env.NEXT_PUBLIC_API}/api/tool/location?ip=${ip}`
    )
    const latlng2 = await latlng1.json()
    const latlng = latlng2.data || {}
    if (latlng && latlng.status === 'success') {
      location = `${latlng.city}, ${latlng.region}`
    }
  } catch (error) {
    console.log(error)
  }

  return {
    props: {
      location
    }
  }
}
